// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from '@leagueplatform/genesis-core';
import '../euclid-circular-a.font.css';

export const medibankAmplarHealthTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: '#F7F7F7FF',
        secondary: '#FFFFFFFF',
        tertiary: '#EDF2F7FF',
      },
      card: {
        primary: '#F7F7F7FF',
        secondary: '#FFFFFFFF',
        disabled: '#000C2414',
      },
      screenHeader: { background: '#EDF2F7FF' },
      skeleton: {
        shimmer: {
          background: '#DDE0E2FF',
          overlay:
            'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
        },
      },
    },
    onSurface: {
      text: {
        primary: '#3A3F4DFF',
        subdued: '#616870FF',
        reversed: '#FFFFFFFF',
        critical: '#B42318FF',
        success: '#1F835FFF',
        warning: '#7D4F05FF',
      },
      border: { subdued: '#DEE0E2FF', default: '#DEE0E2FF', card: '#DEE0E2FF' },
      icon: { primary: '#3A3F4DFF' },
    },
    interactive: {
      action: {
        primary: '#0573B3FF',
        hovered: '#0D5C93FF',
        pressed: '#10416AFF',
        subdued: '#686F78FF',
        disabled: '#000C2433',
      },
      icon: { default: '#FFFFFFFF', disabled: '#D0D5DDFF' },
      background: {
        default: '#FFFFFFFF',
        disabled: '#FFFFFFFF',
        hovered: '#FFFFFFFF',
        pressed: '#FFFFFFFF',
      },
      border: {
        default: '#DEE0E2FF',
        hovered: '#B8BCC1FF',
        disabled: '#E9EAECFF',
        critical: { default: '#CC001FFF' },
      },
      focus: { inner: '#007AC0FF', outer: '#007AC0FF' },
    },
    critical: {
      background: { subdued: '#FDE7EBFF', secondary: '#FFFFFFFF' },
      border: { default: '#CC001FFF' },
      icon: '#CC001FFF',
    },
    warning: {
      background: { subdued: '#FFF3D8FF', secondary: '#FFFFFFFF' },
      border: { default: '#7D4F05FF' },
      icon: '#7D4F05FF',
    },
    success: {
      background: { subdued: '#DCEDE7FF', secondary: '#FFFFFFFF' },
      border: { default: '#1F835FFF' },
      icon: '#1F835FFF',
    },
    highlight: {
      background: { subdued: '#DDECF7FF', secondary: '#FFFFFFFF' },
      border: { default: '#007AC0FF' },
      icon: '#007AC0FF',
    },
    decorative: {
      brand: {
        primary: {
          darkest: '#10416AFF',
          dark: '#0573B3FF',
          default: '#007AC0FF',
          bright: '#9BC4DCFF',
          brightest: '#BBD7E7FF',
          pastel: '#E9F4FCFF',
        },
        secondary: {
          darkest: '#C34C5EFF',
          dark: '#FF7800FF',
          default: '#EE6A7EFF',
          bright: '#F1C9A6FF',
          brightest: '#E9F4FCFF',
          pastel: '#FEF2E9FF',
        },
        tertiary: {
          darkest: '#1A1A1AFF',
          dark: '#4B4B4BFF',
          default: '#7F7F7FFF',
          bright: '#B9B9B9FF',
          brightest: '#ECECECFF',
          pastel: '#FAFAFAFF',
        },
      },
    },
    primary: {
      background: {
        default: '#007AC0FF',
        hovered: '#0D5C93FF',
        pressed: '#10416AFF',
        critical: {
          default: '#CC001FFF',
          hovered: '#9F0018FF',
          pressed: '#850014FF',
        },
      },
      text: { default: '#FFFFFFFF', critical: { default: '#FFFFFFFF' } },
    },
    secondary: {
      background: {
        default: '#000C2414',
        hovered: '#000C2424',
        pressed: '#000C2433',
      },
      text: { default: '#3A3F4DFF', hovered: '#3A3F4DFF' },
      border: { default: '#1A1A1A00' },
    },
    tertiary: {
      background: {
        default: '#FFFFFF00',
        hovered: '#DCDCDC00',
        pressed: '#F0F0F000',
      },
      text: { default: '#0573B3FF', hovered: '#0D5C93FF' },
      border: { default: '#DCDCDC00' },
    },
    input: {
      border: {
        success: '#1F835FFF',
        warning: '#7D4F05FF',
        default: '#DEE0E2FF',
        hovered: '#B8BCC1FF',
        disabled: '#E9EAECFF',
        critical: '#CC001FFF',
      },
      background: {
        default: '#FFFFFFFF',
        disabled: '#FFFFFFFF',
        hovered: '#FFFFFFFF',
        pressed: '#FFFFFFFF',
      },
    },
    dataViz: {
      interface: { track: { border: '#FBE1E6FF', background: '#FBE1E6FF' } },
      singleColor: { brand: '#EE6A7EFF', neutral: '#EAECF0FF' },
      status: {
        critical: '#CC001FFF',
        warning: '#7D4F05FF',
        success: '#1F835FFF',
      },
      categorical: {
        one: '#007AC0FF',
        two: '#EE6A7EFF',
        three: '#10416AFF',
        four: '#1F835FFF',
        five: '#CC001FFF',
        six: '#7D4F05FF',
      },
    },
    tag: {
      neutral: {
        background: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        border: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      one: {
        background: { bold: '#501CD2FF', subdued: '#EDEAF5FF' },
        border: { bold: '#501CD2FF', subdued: '#EDEAF5FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      two: {
        background: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        border: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      three: {
        background: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        border: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      four: {
        background: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        border: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' },
      },
      success: {
        background: { bold: '#3A3F4DFF', subdued: '#EBECEEFF' },
        border: { bold: '#3A3F4DFF', subdued: '#EBECEEFF' },
        text: { bold: '#FFFFFFFF', subdued: '#3A3F4DFF' },
      },
      warning: {
        background: { bold: '#8C919AFF', subdued: '#FAE8D6FF' },
        border: { bold: '#8C919AFF', subdued: '#FAE8D6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#9F3703FF' },
      },
      critical: {
        background: { bold: '#DD0E0EFF', subdued: '#F9E1E2FF' },
        border: { bold: '#DD0E0EFF', subdued: '#F9E1E2FF' },
        text: { bold: '#FFFFFFFF', subdued: '#BB1111FF' },
      },
      informational: {
        background: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        border: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        text: { bold: '#FFFFFFFF', subdued: '#225ECEFF' },
      },
    },
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: '#000000FF' },
    dropdown: { x: 0, y: 3, blur: 7, spread: 0, color: '#0000001A' },
  },
  typography: {
    headingOne: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 600,
      lineHeight: 44,
      fontSize: 36,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingTwo: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingThree: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingFour: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleOne: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 500,
      lineHeight: 20,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleTwo: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 500,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOne: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOneSecondary: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwo: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 400,
      lineHeight: 22,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwoSecondary: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 400,
      lineHeight: 22,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonOne: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonTwo: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 600,
      lineHeight: 16,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    label: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 600,
      lineHeight: 15.215999603271484,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    overline: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 700,
      lineHeight: 15,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'uppercase',
      textDecoration: 'none',
    },
    caption: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 400,
      lineHeight: 22,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    tab: {
      fontFamily: 'Euclid Circular A',
      fontWeight: 500,
      lineHeight: 22,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
    eighth: 2,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 12,
    card: 16,
    progressBar: 9999,
    tags: 4,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.3333333333333333,
      headingThree: 1.1111111111111112,
      headingFour: 0.8888888888888888,
      subtitleOne: 0.8888888888888888,
      subtitleTwo: 0.7777777777777778,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.7777777777777778,
      bodyTwoSecondary: 0.7777777777777778,
      buttonOne: 1,
      buttonTwo: 0.7777777777777778,
      label: 0.6666666666666666,
      overline: 0.6666666666666666,
      caption: 0.7777777777777778,
      tab: 0.5555555555555556,
    },
    lineHeights: {
      headingOne: 2.4444444444444446,
      headingTwo: 1.7777777777777777,
      headingThree: 1.3333333333333333,
      headingFour: 1.3333333333333333,
      subtitleOne: 1.1111111111111112,
      subtitleTwo: 1.1111111111111112,
      bodyOne: 1.3333333333333333,
      bodyOneSecondary: 1.3333333333333333,
      bodyTwo: 1.2222222222222223,
      bodyTwoSecondary: 1.2222222222222223,
      buttonOne: 1.3333333333333333,
      buttonTwo: 0.8888888888888888,
      label: 0.8453333112928603,
      overline: 0.8333333333333334,
      caption: 1.2222222222222223,
      tab: 1.2222222222222223,
    },
    baseSize: 18,
  },
  fonts: { headings: 'Euclid Circular A', body: 'Euclid Circular A' },
  transitions: { defaultTime: '200ms' },
};
